// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/scanPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/scanPage/assignPickBins */
export const useAssignPickBins = makeBackendHook('scanPage', 'assignPickBins')

/** POST /api/rpc/scanPage/callImports */
export const useCallImports = makeBackendHook('scanPage', 'callImports')

/** POST /api/rpc/scanPage/checkInTote */
export const useCheckInTote = makeBackendHook('scanPage', 'checkInTote')

/** POST /api/rpc/scanPage/clearCompleteOrders */
export const useClearCompleteOrders = makeBackendHook('scanPage', 'clearCompleteOrders')

/** POST /api/rpc/scanPage/closeOrderAsShipped */
export const useCloseOrderAsShipped = makeBackendHook('scanPage', 'closeOrderAsShipped')

/** POST /api/rpc/scanPage/commitPick */
export const useCommitPick = makeBackendHook('scanPage', 'commitPick')

/** POST /api/rpc/scanPage/completeOrder */
export const useCompleteOrder = makeBackendHook('scanPage', 'completeOrder')

/** POST /api/rpc/scanPage/decrementProductStock */
export const useDecrementProductStock = makeBackendHook('scanPage', 'decrementProductStock')

/** POST /api/rpc/scanPage/deleteOrder */
export const useDeleteOrder = makeBackendHook('scanPage', 'deleteOrder')

/** POST /api/rpc/scanPage/deleteOrderLine */
export const useDeleteOrderLine = makeBackendHook('scanPage', 'deleteOrderLine')

/** POST /api/rpc/scanPage/flushOrderLineUpdates */
export const useFlushOrderLineUpdates = makeBackendHook('scanPage', 'flushOrderLineUpdates')

/** POST /api/rpc/scanPage/generateLabelsFile */
export const useGenerateLabelsFile = makeBackendHook('scanPage', 'generateLabelsFile')

/** POST /api/rpc/scanPage/generatePicklistFile */
export const useGeneratePicklistFile = makeBackendHook('scanPage', 'generatePicklistFile')

/** POST /api/rpc/scanPage/getAllOrderLines */
export const useGetAllOrderLines = makeBackendHook('scanPage', 'getAllOrderLines')

/** POST /api/rpc/scanPage/getAllOrderShipments */
export const useGetAllOrderShipments = makeBackendHook('scanPage', 'getAllOrderShipments')

/** POST /api/rpc/scanPage/getCompletedDeliveries */
export const useGetCompletedDeliveries = makeBackendHook('scanPage', 'getCompletedDeliveries')

/** POST /api/rpc/scanPage/getDeliveryRoute */
export const useGetDeliveryRoute = makeBackendHook('scanPage', 'getDeliveryRoute')

/** POST /api/rpc/scanPage/getInvoiceProblems */
export const useGetInvoiceProblems = makeBackendHook('scanPage', 'getInvoiceProblems')

/** POST /api/rpc/scanPage/getLabelForecast */
export const useGetLabelForecast = makeBackendHook('scanPage', 'getLabelForecast')

/** POST /api/rpc/scanPage/getLastOrderImport */
export const useGetLastOrderImport = makeBackendHook('scanPage', 'getLastOrderImport')

/** POST /api/rpc/scanPage/getOrderPicklist */
export const useGetOrderPicklist = makeBackendHook('scanPage', 'getOrderPicklist')

/** POST /api/rpc/scanPage/getOrderTotes */
export const useGetOrderTotes = makeBackendHook('scanPage', 'getOrderTotes')

/** POST /api/rpc/scanPage/getShippingRates */
export const useGetShippingRates = makeBackendHook('scanPage', 'getShippingRates')

/** POST /api/rpc/scanPage/getTotes */
export const useGetTotes = makeBackendHook('scanPage', 'getTotes')

/** POST /api/rpc/scanPage/getUnpickedItems */
export const useGetUnpickedItems = makeBackendHook('scanPage', 'getUnpickedItems')

/** POST /api/rpc/scanPage/importZohoOrders */
export const useImportZohoOrders = makeBackendHook('scanPage', 'importZohoOrders')

/** POST /api/rpc/scanPage/markOrderFulfilled */
export const useMarkOrderFulfilled = makeBackendHook('scanPage', 'markOrderFulfilled')

/** POST /api/rpc/scanPage/moveItemToInvoice */
export const useMoveItemToInvoice = makeBackendHook('scanPage', 'moveItemToInvoice')

/** POST /api/rpc/scanPage/postBinLabel */
export const usePostBinLabel = makeBackendHook('scanPage', 'postBinLabel')

/** POST /api/rpc/scanPage/processToteScan */
export const useProcessToteScan = makeBackendHook('scanPage', 'processToteScan')

/** POST /api/rpc/scanPage/purchaseShippingLabels */
export const usePurchaseShippingLabels = makeBackendHook('scanPage', 'purchaseShippingLabels')

/** POST /api/rpc/scanPage/refreshTrackingStatus */
export const useRefreshTrackingStatus = makeBackendHook('scanPage', 'refreshTrackingStatus')

/** POST /api/rpc/scanPage/retryInvoicePushes */
export const useRetryInvoicePushes = makeBackendHook('scanPage', 'retryInvoicePushes')

/** POST /api/rpc/scanPage/sendTrackingEmail */
export const useSendTrackingEmail = makeBackendHook('scanPage', 'sendTrackingEmail')

/** POST /api/rpc/scanPage/setOrdersReadyToPick */
export const useSetOrdersReadyToPick = makeBackendHook('scanPage', 'setOrdersReadyToPick')

/** POST /api/rpc/scanPage/syncB2bOrderStages */
export const useSyncB2bOrderStages = makeBackendHook('scanPage', 'syncB2bOrderStages')

/** POST /api/rpc/scanPage/undoPick */
export const useUndoPick = makeBackendHook('scanPage', 'undoPick')

/** POST /api/rpc/scanPage/updateLineItemQuantity */
export const useUpdateLineItemQuantity = makeBackendHook('scanPage', 'updateLineItemQuantity')

/** POST /api/rpc/scanPage/updateOrderLine */
export const useUpdateOrderLine = makeBackendHook('scanPage', 'updateOrderLine')

/** POST /api/rpc/scanPage/updateOrderStatus */
export const useUpdateOrderStatus = makeBackendHook('scanPage', 'updateOrderStatus')

/** POST /api/rpc/scanPage/updatePickedQuantity */
export const useUpdatePickedQuantity = makeBackendHook('scanPage', 'updatePickedQuantity')
